import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import ua from '@tencent/docs-user-agent';
var getMoveFileService = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(props) {
    var _props$usePcPlatform, usePcPlatform, _yield$import, _getMoveFileService, _yield$import2, getMobileMoveFileService;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _props$usePcPlatform = props.usePcPlatform, usePcPlatform = _props$usePcPlatform === void 0 ? ua.isIPad || ua.isPC : _props$usePcPlatform;
          if (!usePcPlatform) {
            _context.next = 7;
            break;
          }
          _context.next = 4;
          return import("./pc-entry");
        case 4:
          _yield$import = _context.sent;
          _getMoveFileService = _yield$import.getMoveFileService;
          return _context.abrupt("return", _getMoveFileService());
        case 7:
          _context.next = 9;
          return import("./mobile-entry");
        case 9:
          _yield$import2 = _context.sent;
          getMobileMoveFileService = _yield$import2.getMobileMoveFileService;
          return _context.abrupt("return", getMobileMoveFileService());
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getMoveFileService(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var init = function init(options) {
  getMoveFileService({}).then(function (service) {
    service.init(options);
  });
};
export var handleClick = function handleClick() {
  getMoveFileService({}).then(function (service) {
    service.handleClick();
  });
};
export var hide = function hide() {
  getMoveFileService({}).then(function (service) {
    service.hide();
  });
};